module.exports = __webpack_public_path__ + "assets/img/mecha-text-bg-d8d85c70.png";